import { forwardRef, useImperativeHandle, useState } from "react";
import { Button } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { useCustomFieldGroupByTaskTypeId } from "../../data/queries/customFieldGroupQueries";
import { TaskCustomFieldType } from "./TaskCustomFieldType";

export const TaskCustomFields = forwardRef(({ initialValue }, ref) => {
  const { t } = useTranslation(["CreateTaskModal"]);

  const [taskTypeId, setTaskTypeId] = useState(initialValue?.TaskTypeId);
  const [showFields, setShowFields] = useState(initialValue?.TaskCustomFields);
  const [fieldValues, setFieldValues] = useState(
    initialValue?.TaskCustomFields ?? []
  );

  const { data: customFieldGroups, isPending } =
    useCustomFieldGroupByTaskTypeId(taskTypeId, false);

  const handleCustomFieldChange = (id, value) => {
    let itemExists = fieldValues?.find((x) => x.Id == id);
    let newValues = fieldValues;
    if (itemExists) {
      newValues = newValues?.map((x) => {
        if (x.Id === id) {
          x.Value = value;
        }
        return x;
      });
    } else {
      newValues.push({ Id: id, Value: value });
    }
    setFieldValues(newValues);
  };

  useImperativeHandle(
    ref,
    () => ({
      setTaskTypeId,
      getCustomFieldValues: () => fieldValues,
    }),
    [fieldValues]
  );

  if (customFieldGroups?.length === 0 || isPending) return null;

  return (
    <div className="mx-4 py-4 et-bt-light-gray-1 et-task-custom-fields">
      <div className="fs-12">{t("TaskCustomFields.AdditionalDetails")}</div>

      {!showFields ? (
        <div className="show-fields-btn">
          <div className="d-flex justify-content-start align-items-center">
            <Button
              text={t("TaskCustomFields.ShowFields")}
              className="btn-tertiary w-auto fs-12"
              onClick={() => {
                let values = [];
                customFieldGroups?.map((x) =>
                  x.CustomFields?.forEach((field) => {
                    values.push({ Id: field.Id, Value: null });
                  })
                );
                setShowFields(true);
                setFieldValues(values);
              }}
            />
            <div className="fs-12 et-blue">
              ({customFieldGroups?.map((group) => group.Name).join(", ")})
            </div>
          </div>
        </div>
      ) : (
        <div className="remove-fields">
          <Button
            text={t("TaskCustomFields.RemoveFields")}
            className="btn-tertiary w-auto fs-12"
            onClick={() => {
              setShowFields(false);
              setFieldValues([]);
            }}
          />
          <div className="custom-groups">
            {customFieldGroups?.map((group) => (
              <div
                className="custom-group shadow-sm bc-bg-light-gray br-4 mb-2 overflow-hidden"
                key={group?.Id}
              >
                <div className="bg-lightest-gray px-3 py-2 fw-600">
                  {group?.Name}
                </div>
                <div className="fields bg-white et-bt-light-gray-1 px-4 py-3">
                  {group?.CustomFields?.map((customField) => (
                    <div className="py-2" key={customField?.Id}>
                      <TaskCustomFieldType
                        customField={customField}
                        onChange={handleCustomFieldChange}
                        fieldValue={
                          initialValue?.TaskCustomFields?.find(
                            (x) => x.Id == customField?.Id
                          )?.Value
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
});
